import Graphic from "@arcgis/core/Graphic";
import FeatureSet from "@arcgis/core/rest/support/FeatureSet";
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";

const gpUrl = "https://ispacevm09.researchstudio.at/arcgis/rest/services/HaltestellenAnalyse/GetServiceAreasWebTool2025/GPServer/GetServiceAreasWebTool%202025"

// Constants for styling
const STYLE_CONSTANTS = {
    POLYGON: {
        fillColor: "rgba(139,164,221,0.1)",
        outlineColor: "rgb(85,64,88)",
        outlineWidth: "2px"
    },
    // // commented out for not visualizing polylines
    // POLYLINE: {
    //     color: "rgb(170,81,169)",
    //     width: 2
    // },
    POINT: {
        color: "white",
        size: 10
    }
};

// Create a graphic for the input point
function createGraphic(view, point){
    if (!view || !point) {
        throw new Error('View and point are required parameters');
    }
    view.graphics.removeAll();
    const graphic = new Graphic({
        geometry: point,
        symbol: {
            type: "simple-marker",
            ...STYLE_CONSTANTS.POINT
        }
    });

    view.graphics.add(graphic);
    return graphic;
}

/**
 * Gets service area analysis results
 * @param {__esri.MapView} view - The map view
 * @param {__esri.Point} point - The point geometry
 * @param {number[]} cutoffs - Array of distance values
 * @returns {Promise<__esri.Geometry[]>} Array of result geometries
 */
async function gpGetServiceArea(view, point, cutoffs){
    try {
        // Input validation
        if (!view || !point || !Array.isArray(cutoffs)) {
            throw new Error('Invalid input parameters');
        }
        const locationGraphic = createGraphic(view,point)
        // create input featureSet
        const facilitiesFeatureSet = new FeatureSet({
            features: [locationGraphic]
        })

        const params = {
            Facilities: facilitiesFeatureSet,
            BreakValues: cutoffs, // Example cutoff values in kilometers
        };

        const response = await geoprocessor.execute(gpUrl, params);
        return processServiceAreaResults(view, response.results)
    }catch (error) {
        console.error("Error executing service area analysis", error);
        throw error;
    }
}

/**
 * Process and visualize service area results
 * @param {__esri.MapView} view - The map view
 * @param {Array} results - Geoprocessing results
 * @returns {__esri.Geometry[]} Array of result geometries
 */
function processServiceAreaResults(view, results){
    const [polygonResult, polylineResult] = results;
    const resultGeometries = [];

    // check if anything is null or undefined
    if (polygonResult?.value?.features?.length) {
        const polygons = [...polygonResult.value.features].reverse();

        polygons.forEach(feature => {
            feature.symbol = {
                type: "simple-fill",
                color: STYLE_CONSTANTS.POLYGON.fillColor,
                outline: {
                    color: STYLE_CONSTANTS.POLYGON.outlineColor,
                    width: STYLE_CONSTANTS.POLYGON.outlineWidth
                }
            };
            view.graphics.add(feature, 0);
            resultGeometries.push(feature.geometry);
        });

        // // commented out for not visualizing polylines
        // // check if anything is null or undefined
        // if (polylineResult?.value?.features?.length) {
        //     polylineResult.value.features.forEach(feature => {
        //         feature.symbol = {
        //             type: "simple-line",
        //             color: STYLE_CONSTANTS.POLYLINE.color,
        //             width: STYLE_CONSTANTS.POLYLINE.width
        //         };
        //         view.graphics.add(feature, 1);
        //     });
        // }
    }

    return resultGeometries;
}

export default gpGetServiceArea;
